@if (isStandaloneLayout()) {
  <button
    (click)="onStandaloneButtonClick($event)"
    class="flex items-center gap-2 rounded-full px-2 py-1"
    [ngClass]="
      activeAlertsCount() >= 1
        ? 'bg-interface-warning-muted-default text-text-warning-default hover:bg-interface-warning-muted-hover'
        : 'bg-interface-positive-muted-default text-text-positive-default hover:bg-interface-positive-muted-hover'
    "
  >
    <div
      class="aspect-square w-2 rounded-full"
      [ngClass]="
        activeAlertsCount() >= 1
          ? 'bg-text-warning-default'
          : 'bg-text-positive-default'
      "
    ></div>
    <span class="text-sm">
      {{ activeAlertsCount() }}
      <ng-container [ngPlural]="activeAlertsCount()">
        <ng-template ngPluralCase="=1"> Alert </ng-template>
        <ng-template ngPluralCase="other"> Alerts </ng-template>
      </ng-container>
    </span>
    <span
      class="inline-block transition-transform duration-200"
      [class.rotate-180]="alertsPopoverVisible() || drawerVisible()"
    >
      <svg-icon src="assets/icons/general/chevron-down.svg" />
    </span>
  </button>
}

@if (isMenuLayout()) {
  <p-button
    variant="text"
    severity="contrast"
    styleClass="w-full !justify-start"
    (click)="alertsPopover.toggle($event)"
  >
    <svg-icon src="assets/icons/general/system-feedback-warning.svg" />
    <span>Alerts</span>
    <div
      class="typography-labels-medium-emphasis ml-auto grid h-6 place-items-center rounded-full px-1"
      [ngClass]="
        activeAlertsCount() >= 1
          ? 'bg-interface-warning-muted-default text-text-warning-default'
          : 'bg-interface-positive-muted-default text-text-positive-default'
      "
    >
      {{ activeAlertsCount() }}
    </div>
  </p-button>
}

<p-popover
  #alertsPopover
  styleClass="[&_.p-popover-content]:!p-2"
  appendTo="body"
  (onShow)="onAlertsPopoverShow()"
  (onHide)="onAlertsPopoverHide()"
>
  <div
    class="flex max-h-[300px] min-w-[20rem] flex-col"
    [ngClass]="isMenuLayout() ? 'max-w-[23rem]' : 'max-w-[26rem]'"
    (click)="$event.stopPropagation()"
    (mousedown)="$event.stopPropagation()"
    (touchstart)="$event.stopPropagation()"
  >
    <div class="flex items-center pl-1">
      <span class="typography-headings-small text-text-common-contrast">
        {{ alertsTitle() }}
      </span>
      <div class="ml-auto flex items-center">
        <div class="relative">
          @if (showFilterIndicator()) {
            <div
              class="absolute right-0 top-0 z-50 block aspect-square w-2 rounded-full bg-interface-primary-color"
            ></div>
          }
          <p-button
            size="small"
            severity="contrast"
            variant="text"
            pTooltip="Filter"
            tooltipPosition="left"
            (click)="onFilterButtonClick($event)"
          >
            <ng-template #icon>
              <svg-icon src="assets/icons/general/action-filter.svg" />
            </ng-template>
          </p-button>
        </div>

        <p-button
          size="small"
          variant="text"
          severity="contrast"
          pTooltip="Bulk actions"
          tooltipPosition="left"
          (click)="onBulkActionsButtonClick($event)"
        >
          <ng-template #icon>
            <svg-icon src="assets/icons/general/kebab.svg" />
          </ng-template>
        </p-button>

        <p-button
          size="small"
          variant="text"
          severity="contrast"
          pTooltip="Settings"
          tooltipPosition="left"
          (click)="openSettings()"
        >
          <svg-icon src="assets/icons/general/settings.svg" />
        </p-button>
      </div>
    </div>

    @if (isLoading()) {
      <ng-container *ngTemplateOutlet="alertsLoadingTemplate" />
    } @else if (filteredAlertsCount() === 0) {
      <ng-container *ngTemplateOutlet="alertsEmpty" />
    } @else {
      <ng-container *ngTemplateOutlet="alertsTemplate" />
    }
  </div>
</p-popover>

<p-drawer
  styleClass="!w-[30rem]"
  [visible]="drawerVisible()"
  (visibleChange)="drawerVisible.set($event)"
  position="right"
  maskStyle="opacity: 0"
>
  <ng-template #header>
    <div class="flex w-full items-center">
      <h1 class="typography-headings-small whitespace-nowrap p-1">
        {{ alertsTitle() }}
      </h1>

      <div class="ml-auto flex items-center gap-1">
        <div class="relative">
          @if (showFilterIndicator()) {
            <div
              class="absolute right-0 top-0 z-50 block aspect-square w-2 rounded-full bg-interface-primary-color"
            ></div>
          }
          <p-button
            size="small"
            severity="contrast"
            variant="text"
            pTooltip="Filter"
            tooltipPosition="left"
            (click)="onFilterButtonClick($event)"
          >
            <ng-template #icon>
              <svg-icon src="assets/icons/general/action-filter.svg" />
            </ng-template>
          </p-button>
        </div>

        <p-button
          size="small"
          variant="text"
          severity="contrast"
          pTooltip="Bulk actions"
          tooltipPosition="left"
          (click)="onBulkActionsButtonClick($event)"
        >
          <ng-template #icon>
            <svg-icon src="assets/icons/general/kebab.svg" />
          </ng-template>
        </p-button>

        <p-button
          size="small"
          severity="contrast"
          variant="text"
          pTooltip="Settings"
          tooltipPosition="left"
          (click)="openSettings()"
        >
          <ng-template #icon>
            <svg-icon src="assets/icons/general/settings.svg" />
          </ng-template>
        </p-button>
      </div>
    </div>
  </ng-template>

  @if (isLoading()) {
    <ng-container *ngTemplateOutlet="alertsLoadingTemplate" />
  } @else if (filteredAlertsCount() === 0) {
    <ng-container *ngTemplateOutlet="alertsEmpty" />
  } @else {
    <div class="h-[calc(100vh-7rem)] overflow-y-auto">
      <ng-container *ngTemplateOutlet="alertsTemplate" />
    </div>
  }
</p-drawer>

<p-popover
  #alertFilterPopover
  appendTo="body"
  styleClass="[&_.p-popover-content]:!p-0"
  (onShow)="onAlertFilterPopoverShow()"
  (onHide)="onAlertFilterPopoverHide()"
>
  <ng-template #content>
    <div
      (click)="$event.stopPropagation()"
      (mousedown)="$event.stopPropagation()"
      (touchstart)="$event.stopPropagation()"
    >
      <p-listbox
        class="w-[14rem]"
        optionLabel="label"
        highlightOnSelect="false"
        [options]="filterOptions"
        [ngModel]="selectedFilter()"
        (ngModelChange)="onFilterSelectionChange($event)"
      >
        <ng-template let-item pTemplate="item">
          <div class="flex w-full items-center gap-2">
            <svg-icon
              [src]="item.iconUrl"
              class="shrink-0 text-text-common-primary"
            />
            <span class="typography-body-default text-text-common-contrast">
              {{ item.label }}
            </span>
            @if (selectedFilter()?.value === item.value) {
              <svg-icon
                src="assets/icons/general/check.svg"
                class="ml-auto shrink-0 text-text-common-primary"
              />
            }
          </div>
        </ng-template>
      </p-listbox>
    </div>
  </ng-template>
</p-popover>

<p-popover
  #alertBulkActionsPopover
  appendTo="body"
  styleClass="[&_.p-popover-content]:!p-0"
  (onShow)="onAlertBulkActionsPopoverShow()"
  (onHide)="onAlertBulkActionsPopoverHide()"
>
  <ng-template #content>
    <div
      (click)="$event.stopPropagation()"
      (mousedown)="$event.stopPropagation()"
      (touchstart)="$event.stopPropagation()"
    >
      <p-listbox
        class="w-[14rem]"
        optionLabel="label"
        highlightOnSelect="false"
        [options]="bulkActionOptions"
        [ngModel]="selectedBulkAction()"
        (ngModelChange)="onBulkActionSelectionChange($event)"
      >
        <ng-template let-item pTemplate="item">
          <div class="flex w-full items-center gap-2">
            <!-- Leading icon -->
            <svg-icon
              [src]="item.iconUrl"
              class="shrink-0 text-text-common-primary"
            />

            <!-- Label -->
            <span class="typography-body-default text-text-common-contrast">
              {{ item.label }}
            </span>

            <!-- Checkmark -->
            @if (selectedBulkAction()?.value === item.value) {
              <svg-icon
                src="assets/icons/general/check.svg"
                class="ml-auto shrink-0 text-text-common-primary"
              />
            }
          </div>
        </ng-template>
      </p-listbox>
    </div>
  </ng-template>
</p-popover>

<ng-template #alertsEmpty>
  <div class="grid h-full w-full place-items-center px-2 py-5">
    <div class="flex flex-col items-center gap-2.5">
      <svg-icon src="assets/icons/general/system-feedback-smiley-face.svg" />
      <span class="text-text-common-contrast">
        You're all good nothing to worry about here.
      </span>
      <span class="typography-body-default text-center text-text-common-base">
        We'll notify you when any critical alerts come through.
      </span>
    </div>
  </div>
</ng-template>

<ng-template #alertsLoadingTemplate>
  <div
    class="grid h-full w-full place-items-center gap-2 rounded-xl bg-white p-5"
  >
    <ag1-loader />
  </div>
</ng-template>

<ng-template #alertsTemplate>
  <div class="flex flex-col overflow-y-auto pr-1">
    <!-- Today -->
    @if (alertsToday().length > 0) {
      <div class="flex flex-col">
        <span class="typography-overlines-small text-text-common-base">
          TODAY
        </span>
        <div class="flex flex-col">
          @for (alert of alertsToday(); track alert.id) {
            <ng-container
              *ngTemplateOutlet="alertItemTemplate; context: { alert: alert }"
            />
          }
        </div>
      </div>
    }

    <!-- Yesterday -->
    @if (alertsYesterday().length > 0) {
      <div class="flex flex-col">
        <span class="typography-overlines-small text-text-common-base">
          YESTERDAY
        </span>
        <div class="flex flex-col">
          @for (alert of alertsYesterday(); track alert.id) {
            <ng-container
              *ngTemplateOutlet="alertItemTemplate; context: { alert: alert }"
            />
          }
        </div>
      </div>
    }

    <!-- Older -->
    @if (alertsOlder().length > 0) {
      <div class="flex flex-col">
        <span class="typography-overlines-small text-text-common-base">
          OLDER
        </span>
        <div class="flex flex-col">
          @for (alert of alertsOlder(); track alert.id) {
            <ng-container
              *ngTemplateOutlet="alertItemTemplate; context: { alert: alert }"
            />
          }
        </div>
      </div>
    }
  </div>
</ng-template>

<ng-template #alertItemTemplate let-alert="alert">
  <div
    class="group grid cursor-pointer grid-cols-[auto_1fr] items-center gap-2.5 rounded-lg px-2 py-3.5 hover:bg-interface-common-hover"
    (click)="onAlertClick(alert)"
  >
    <div
      class="w-fit rounded-xl border border-interface-warning-border-default bg-interface-warning-muted-default p-2 text-text-warning-default"
    >
      <svg-icon [src]="alert?.iconPath" />
    </div>

    <div class="relative flex flex-col gap-2">
      <div
        class="absolute right-0 top-0 z-10 hidden cursor-pointer rounded-xl bg-interface-surface-0 p-1.5 group-hover:block"
        (click)="$event.stopPropagation()"
      >
        @if (!alert?.read_at) {
          <p-button
            size="small"
            variant="text"
            severity="contrast"
            pTooltip="Mark as read"
            tooltipPosition="left"
            (click)="onToggleMarkAsRead(alert)"
          >
            <svg-icon src="assets/icons/general/system-feedback-success.svg" />
          </p-button>
        } @else {
          <p-button
            size="small"
            variant="text"
            severity="contrast"
            pTooltip="Mark as unread"
            tooltipPosition="left"
            (click)="onToggleMarkAsRead(alert)"
          >
            <svg-icon src="assets/icons/general/communication-unread.svg" />
          </p-button>
        }

        <p-button
          size="small"
          variant="text"
          severity="contrast"
          pTooltip="Archive"
          tooltipPosition="left"
          (click)="onAlertArchive(alert)"
        >
          <svg-icon src="assets/icons/general/action-archive.svg" />
        </p-button>
      </div>

      <div class="grid grid-cols-[1fr_auto] items-start">
        <span
          class="typography-headings-x-small line-clamp-2 select-none text-text-common-contrast"
        >
          {{ alert?.title }}
        </span>

        <div class="ml-auto flex items-center gap-1.5">
          <ag1-time-since
            class="shrink-0 whitespace-nowrap"
            prefix=""
            [timestamp]="alert?.sent_at?.toISOString()"
          />

          @if (!alert?.read_at) {
            <div
              class="relative mr-1.5 aspect-square w-2 rounded-full bg-bright-red-500"
            ></div>
          }
        </div>
      </div>

      <p
        class="typography-body-small line-clamp-2 select-none text-text-common-contrast"
      >
        {{ alert?.body }}
      </p>
    </div>
  </div>
</ng-template>
